<template>
  <div class="InspectRoomQuestions">
    <Header
      showBack
      showCreate
      :showOperation="false"
      :showHome="false"
      @back="_back"
      @create="_create"
    />

    <div class="content">
      <div class="content-title">{{ areaName }}</div>

      <div class="showHide" @click="changeShowAll(!showAll)">
        <svg-icon
          iconClass="show-yj"
          style="width: 18px; height: 12px"
          v-if="showAll"
        ></svg-icon>
        <svg-icon
          iconClass="hide-yj"
          style="width: 18px; height: 12px"
          v-else
        ></svg-icon>
        <span>{{ stringList.ShowQuestions }}</span>
      </div>
      <div class="list">
        <QuestionItem
          v-for="(item, index) in inspectionItemResponseList"
          :ref="`QuestionItemRef${index}`"
          :key="index"
          :item="item"
          :index="index"
          :roomNumber="roomNumber"
          @update:item="updateItem(index, $event)"
        />
      </div>
    </div>

    <div class="footer">
      <van-button
        :spinning="true"
        class="button"
        @click="handleSubmit"
        native-type="submit"
        >{{ stringList.save }}</van-button
      >
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import QuestionItem from "./components/QuestionItem.vue";
import { mapGetters } from "vuex";

export default {
  name: "InspectRoomQuestions",
  components: {
    Header,
    QuestionItem,
  },
  data() {
    return {
      showAll: false,
      roomNumber: "",
      areaId: "",
      areaName: "",
      inspectionItemResponseList: [],
    };
  },
  computed: {
    ...mapGetters({
      stringList: "stringList",
      userInfo: "userInfo",
    }),
  },
  watch: {
    inspectionItemResponseList: {
      handler(newValue) {
        console.log("inspectionItemResponseList", newValue);
      },
      immediate: true,
      deep: true,
    },
  },
  activated() {
    if (["/InspectRoomArea"].includes(this.$store.state.router.routeFromPath)) {
      const { roomNumber, areaId, areaName, inspectionItemResponseList } =
        JSON.parse(this.$route.query.dataForm);
      this.roomNumber = roomNumber;
      this.areaId = areaId;
      this.areaName = areaName;
      this.inspectionItemResponseList = inspectionItemResponseList;
      this.changeShowAll(false);
    }
  },
  created() {
    const { roomNumber, areaId, areaName, inspectionItemResponseList } =
      JSON.parse(this.$route.query.dataForm);
    this.roomNumber = roomNumber;
    this.areaId = areaId;
    this.areaName = areaName;
    this.inspectionItemResponseList = inspectionItemResponseList;
    this.changeShowAll(false);
  },
  methods: {
    _create() {
      this.$router.push({
        path: "/NewTicket",
        query: { roomNumber: this.roomNumber },
      });
    },
    changeShowAll(flag) {
      if (!flag) {
        this.$nextTick(() => {
          this.inspectionItemResponseList.forEach((item, index) => {
            this.$refs[`QuestionItemRef${index}`][0].showDes = false;
          });
        });
      } else {
        this.$nextTick(() => {
          this.inspectionItemResponseList.forEach((item, index) => {
            this.$refs[`QuestionItemRef${index}`][0].showDes = true;
          });
        });
      }
      this.showAll = flag;
    },
    updateItem(index, updatedItem) {
      this.$set(this.inspectionItemResponseList, index, updatedItem);

      if (updatedItem && updatedItem.isWrong && updatedItem.notes) {
        this.$set(this.inspectionItemResponseList[index], "errorType", "");
      }

      if (updatedItem && updatedItem.isWrong && !updatedItem.notes) {
        this.$set(this.inspectionItemResponseList[index], "errorType", 1);
      }
    },

    handleSubmit() {
      let index = this.inspectionItemResponseList.findIndex((item) => {
        return item.errorType == 1;
      });

      if (index > -1) {
        return;
      }

      this.inspectionItemResponseList.forEach((item, index) => {
        if (item.isWrong && !item.motes) {
          this.$set(this.inspectionItemResponseList[index], "errorType", 1);
        } else {
          this.$set(this.inspectionItemResponseList[index], "errorType", "");
        }
      });

      let list = this.inspectionItemResponseList.map((item) => {
        return {
          ...item,
          isWrong: item.img.length > 0 || item.notes,
          errorType: item.isWrong && item.notes ? 1 : "",
        };
      });

      this.$store.commit("SET_QUESTION_BACK_DATA", {
        areaId: this.areaId,
        inspectionItemResponseList: list,
      });

      this.$router.go(-1);
    },
    _back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.InspectRoomQuestions {
  flex: 1;
  background-color: #f2f2f2;
  overflow-y: auto;
}

.content {
  min-height: 374px;
  padding: 24px 1.75rem;
  opacity: 1;
  background: #ffffff;

  .content-title {
    height: 26px;
    opacity: 1;
    font-family: Arial;
    font-size: 22px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    color: #5a578c;
    margin-bottom: 16px;
  }

  .showHide {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    span {
      font-size: 14px;
      font-weight: normal;
      line-height: 18.72px;
      color: #3d3d3d;
      margin-left: 10px;
    }
  }

  .list {
    margin-top: 10px;
  }
}

.footer {
  margin: 24px auto 32px;
  .button {
    width: 200px;
    height: 48px;
    border-radius: 8px;
    opacity: 1;
    background: #ff6600;
    font-family: Arial;
    font-size: 16px;
    font-weight: 700;
    line-height: 18.72px;
    text-align: center;
    // display: flex;
    // align-items: center;
    letter-spacing: 0em;
    color: #ffffff;
    border: 0;
  }
}
</style>
